import '@babel/polyfill';
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout';
import testData from './layout/assets/testData.json';

window.allData = window.allData && Object.keys(window.allData).length ? window.allData : testData;

/* eslint-disable no-undef */
ReactDOM.render(<Layout content={allData} fontDiff={__fontDiff} />, document.getElementById('root'));
/* eslint-enable no-undef */
